import * as riot from 'riot';
import App from './components/app.riot';
import registerGlobalComponents from '/src/utils/register-global-components';
import { Route, Router } from '@riotjs/route';

import eventBus from '/src/utils/event-bus';

// Registra i componenti globali come header, footer, ecc
registerGlobalComponents();

// Registra globalmente Router e Route
riot.register('router', Router);
riot.register('route', Route);

// Monta il componente principale dell'applicazione
const mountApp = riot.component(App)
//const mountApp = riot.component(Demo)
const app = mountApp(document.getElementById('root'))